module.exports = __webpack_public_path__ + "static/media/blue-hero-car.27b44d22.png";